import React from 'react';
import DateFormatter from '../../shims/date-formatter.js';
import "./sass/boss-option.scss";

function BossOption({
  selected=true,
  select=()=>{},
  details,
  bossEligible = false
}) {

  const {
    estimatedStartDeliveryDate,
    estimatedEndDeliveryDate,
    bossEstimatedShippingStartDate,
    bossEstimatedShippingEndDate,
    isBackordered,
    backorderExpectedShipDate,
    isPurchasableInLocalStoreBoss,
    isZeroStockInLocalStoreBoss,
    bossShippingExclusionApplies,
    store,
    storeBossEligible,
    bossEligibleCatalog,
    enabled,
  } = details;

  const enabledCheck =
    enabled && (
      !(details.installSelected || details.quantityError) ||
      (bossEligible && !details.bossShippingExclusionApplies)
    );

  const getExcludedStateName = (store={}) => {
    const stateCode = store.statecode;
    return stateCode.match("HI") ? "Hawaii" : stateCode.match("AK") ? "Alaska" : stateCode;
  }

  const cssBossBase = "pickupTile card card-container card-background";
  const cssSelectedEnabled = cssBossBase+" card-selected card-enabled";
  const cssSelectedDisabled = cssBossBase+" card-selected card-unselected";
  const cssUnselectedEnabled = cssBossBase+" card-unselected card-enabled";
  const cssUnselectedDisabled = cssBossBase+" card-unselected card-unselected";
  const enabledCss = selected ? cssSelectedEnabled : cssUnselectedEnabled ;
  const disabledCss = selected ? cssSelectedDisabled : cssUnselectedDisabled;

  let dateRange = estimatedStartDeliveryDate !== estimatedEndDeliveryDate;

  let expectItDate = dateRange?
    DateFormatter.convertLongMonthToShort(estimatedStartDeliveryDate)+' - '+
    DateFormatter.convertLongMonthToShort(estimatedEndDeliveryDate):"";

  let bossDateRange = bossEstimatedShippingStartDate !== bossEstimatedShippingEndDate;
  let bossExpectItDate = bossDateRange?
    DateFormatter.convertLongMonthToShort(bossEstimatedShippingStartDate)+' - '+
    DateFormatter.convertLongMonthToShort(bossEstimatedShippingEndDate):"";

  const pickUpLabel =
    ((dateRange && !(isBackordered && !backorderExpectedShipDate)) ||
    (isPurchasableInLocalStoreBoss || isZeroStockInLocalStoreBoss)) &&
    <div className="tile-message ship-to-store__message">
      <div>
        <span className="dai_tileMessage">
          Pickup
        </span>
      </div>
    </div>;

  const backOrderLabel =
    <div className="tile-message ship-to-store__message dai_tileMessage">Backordered</div>;

  const bossPickUpDate = !(isBackordered && !backorderExpectedShipDate) &&
    !bossShippingExclusionApplies &&
    (bossExpectItDate || expectItDate) &&
    <span className="tile-message tile-date ship-to-store__message ship-to-store__message--bold dai_tileDate">
      {(isPurchasableInLocalStoreBoss || isZeroStockInLocalStoreBoss) ?
        bossExpectItDate:
        expectItDate
      }
    </span>;

  const freePriceText =
    <div className="fulfillment__price-wrapper card-messaging-bottom">
      <span className="u__text--success dai_tilePrice">
        FREE
      </span>
    </div>;

  const enabledBossTile =
    <div className={enabledCss} onClick={()=>{select('PICKUP')}}>
      <div className="ship-to-store__wrapper">
        <div className="ship-to-store__icon pick-up-true"/>
        <div className="tile-heading ship-to-store__heading dai_tileHeading">Ship to Store</div>
        {isBackordered ? backOrderLabel : pickUpLabel}
        {bossPickUpDate}
      </div>
      {freePriceText}
    </div>;

  const notAvailableItem =
    <div className="ship-to-store__message-wrapper">
      <div id="unavailable-text" className="tile-message ship-to-store__message ship-to-store__message--boss-unavailable dai_tileMessage">
        Not available for this item
      </div>
    </div>;

  const notSoldInStore =
      <div className="ship-to-store__message-wrapper">
        <div id="notSoldeInStores-text" className="tile-message ship-to-store__message ship-to-store__message--boss-unavailable dai_tileMessage">
          Not sold in stores
        </div>
      </div>;

  const notAvailableExcludedShipping =
    <div className="ship-to-store__message-wrapper">
      <div className="tile-message ship-to-store__message dai_tileMessage">
        Not available in {getExcludedStateName(store)}
      </div>
      <div className="u__center">
        <span className="u__text--success dai_tilePrice">
          <div className="dai_pickupTileMessage_checkNearby change-store">
            <a href="#" className="u__default-link store-inventory-finder-trigger">
              Change Store
            </a>
          </div>
        </span>
      </div>
    </div>;

  const disabledBossTile =
    <div className={disabledCss}>
      <div className="ship-to-store__wrapper ship-to-store__wrapper--disabled">
        <div className="ship-to-store__icon pick-up-false"/>
        <div className="tile-heading ship-to-store__heading dai_tileHeading">Ship to Store</div>
        {bossShippingExclusionApplies ?
          notAvailableExcludedShipping :
            bossEligibleCatalog ?
              (!storeBossEligible && notAvailableItem) :
              notSoldInStore
        }
      </div>
    </div>;

  return enabledCheck ? enabledBossTile : disabledBossTile;
}

export default BossOption;
